import React from 'react';
import {BaseComponent as Component} from 'BaseComponent';
import FilterInput from './filter-input';
import FilterSlider from './filter-slider';
import Tooltip from 'components/atoms/tooltip';
import {RangeLimits} from 'components/organisms/range-of-outcomes/helpers';
import Const from 'constants';

const labelsMap = {
    hitter: 'Hitters Randomization %',
    pitcher: 'Pitchers Randomization %',
};

function getPositionsGroup(positionsGroupName) {
    const positionsMap = Const.MLB_POSITIONS_MAP;

    if (positionsGroupName in positionsMap) {
        return positionsMap[positionsGroupName];
    }

    throw new Error(`Unknown positionsGroupName "${positionsGroupName}"`);
}

function getLabel(positionsGroupName) {
    if (positionsGroupName in labelsMap) {
        return labelsMap[positionsGroupName];
    }

    throw new Error(`Unknown positionsGroupName "${positionsGroupName}"`);
}

class RangeOfOutcomesByPositionsComponent extends Component {
    render() {
        const {useDragging, config, positionsGroupName = ''} = this.props;
        const rangeLimits = new RangeLimits(config.sport);

        const positionsGroup = getPositionsGroup(positionsGroupName);
        const label = getLabel(positionsGroupName);

        return (
            <div>
                <strong className="filter-title">
                    <Tooltip subject="Setting this number to 5 will apply a ±5% randomization to the players' projections for every lineup generated." />
                    {label}
                </strong>
                <div className="range-holder">
                    <div className="slider-wrap">
                        <FilterSlider
                            rangeLimits={rangeLimits}
                            positionsGroup={positionsGroup}
                            step={1}
                            useDragging={useDragging}
                        />
                    </div>
                    <div className="range-wrap">
                        <FilterInput
                            positionsGroup={positionsGroup}
                            rangeLimits={rangeLimits}
                            testId={`${positionsGroupName}-randomization-input`}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default RangeOfOutcomesByPositionsComponent;
